/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerDeactivationDto } from '../models/customer-deactivation-dto';
import { updateCustomerActivation } from '../fn/customer-activation-controller/update-customer-activation';
import { UpdateCustomerActivation$Params } from '../fn/customer-activation-controller/update-customer-activation';
import { validateCustomerDeactivation } from '../fn/customer-activation-controller/validate-customer-deactivation';
import { ValidateCustomerDeactivation$Params } from '../fn/customer-activation-controller/validate-customer-deactivation';


/**
 * Manage and validate customer activation state
 */
@Injectable({ providedIn: 'root' })
export class CustomerActivationControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateCustomerActivation()` */
  static readonly UpdateCustomerActivationPath = '/customers/{customerId}/activation';

  /**
   * Activate or deactivate a free/individual customer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomerActivation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomerActivation$Response(params: UpdateCustomerActivation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCustomerActivation(this.http, this.rootUrl, params, context);
  }

  /**
   * Activate or deactivate a free/individual customer
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomerActivation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomerActivation(params: UpdateCustomerActivation$Params, context?: HttpContext): Observable<void> {
    return this.updateCustomerActivation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `validateCustomerDeactivation()` */
  static readonly ValidateCustomerDeactivationPath = '/customers/{customerId}/activation/validate-deactivation';

  /**
   * Validate the current state of deactivability of a free/individual customer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateCustomerDeactivation()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateCustomerDeactivation$Response(params: ValidateCustomerDeactivation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDeactivationDto>> {
    return validateCustomerDeactivation(this.http, this.rootUrl, params, context);
  }

  /**
   * Validate the current state of deactivability of a free/individual customer
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateCustomerDeactivation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateCustomerDeactivation(params: ValidateCustomerDeactivation$Params, context?: HttpContext): Observable<CustomerDeactivationDto> {
    return this.validateCustomerDeactivation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDeactivationDto>): CustomerDeactivationDto => r.body)
    );
  }

}
